export default __webpack_public_path__ + "static/media/Price.367cf327.jpg";